import { type Listing } from '@pkgs/api/models';
import { Wrapper } from '@ev-tech/ui-core-components/Wrapper';

import { hasCountrySpecificPropertyDetail, hasEnergyInfo, hasExtraInfo } from '@/utils/propertyDataUtils';

import { PropertyDetailsExtraInfo } from './PropertyDetailsExtraInfo';
import { PropertyDetailsEnergyInfo } from './PropertyDetailsEnergyInfo';
import { CountrySpecificPropertyDetail } from './CountrySpecificPropertyDetail';

import styles from './PropertyDetails.module.css';

export const PropertyDetails = ({ listing }: { listing: Listing }) => {
  return (
    <section className={styles.section}>
      <Wrapper className={styles.propertyDetailsWrapper} as="section" width={{ laptop: 'l', tabletLandscape: 'l' }}>
        <div className={styles.container} data-testid="property-details">
          {hasExtraInfo(listing) && <PropertyDetailsExtraInfo listing={listing} />}
          {hasEnergyInfo(listing) && <PropertyDetailsEnergyInfo listing={listing} />}
          {hasCountrySpecificPropertyDetail(listing) && <CountrySpecificPropertyDetail listing={listing} />}
        </div>
      </Wrapper>
    </section>
  );
};
